
import React from 'react';

const PendingVerificationCard: React.FC = () => {
  return (
    <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 mb-6">
      <h2 className="text-xl font-semibold text-blue-800 mb-2">Account Pending Verification</h2>
      <p className="text-blue-700 mb-4">
        Thanks for signing up! Our team is reviewing your account. You'll receive an email once you're approved.
      </p>
      <p className="text-sm text-blue-600">
        If you need immediate assistance, please contact our support team.
      </p>
    </div>
  );
};

export default PendingVerificationCard;
